<template>
    <ElementLayout :parent="parent" :element="element">
        <ckeditor :editor="editor" v-model="element.value" :config="editorConfig" />

    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'


export default {
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                removePlugins: [ 'Heading', 'UndoUI' ]
            }
        }
    },

    components: {
        ElementLayout,
    },

    props: {
        element: Object,
        parent: Object,
    },

    computed: {

    },

    methods: {
        fieldChanged(newVal) {
            this.$emit('change', {value: newVal, previousValue: this.originalValue})
            this.originalValue = newVal
        },
        updateValue(newValue) {
            this.element.value = newValue
        },
    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// HtmlControl.vue?329f50be